class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("[data-load-more]");
    this.spinner = this.querySelector(".loading-overlay__spinner");
    this.grid = document.getElementById("product-grid");
    this.nextUrl = this.dataset.nextUrl;
    this.isLoading = false;

    this.button?.addEventListener("click", this.onClick.bind(this));
  }

  setLoading(loading) {
    this.isLoading = loading;
    this.button?.classList.toggle("loading", loading);
    this.button?.toggleAttribute("disabled", loading);
    this.button?.setAttribute("aria-busy", loading ? "true" : "false");
    this.spinner?.classList.toggle("hidden", !loading);
  }

  async onClick(event) {
    event.preventDefault();
    if (this.isLoading || !this.nextUrl || !this.grid) return;

    this.setLoading(true);

    try {
      const url = new URL(this.nextUrl, window.location.origin);
      url.searchParams.set("section_id", this.grid.dataset.id);

      const response = await fetch(url.toString());
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newGrid = html.getElementById("product-grid");

      if (!newGrid) return;

      Array.from(newGrid.children).forEach((child) => {
        this.grid.appendChild(child);
      });

      if (typeof initializeScrollAnimationTrigger === "function") {
        initializeScrollAnimationTrigger(this.grid);
      }

      const nextLoadMore = html.querySelector("load-more");
      const nextUrl = nextLoadMore?.dataset.nextUrl;

      if (nextUrl) {
        this.nextUrl = nextUrl;
        this.dataset.nextUrl = nextUrl;
      } else {
        this.remove();
      }
    } catch (error) {
      console.error("Load more failed:", error);
    } finally {
      if (this.isConnected) this.setLoading(false);
    }
  }
}

customElements.define("load-more", LoadMore);
